import moment from "moment";
import React, { useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import MomentFunc from "../../../utils/MomentDateTime";
import { useDispatch } from "react-redux";
import ConfirmationModal from "../CommanModals/ConfirmationModal";

const ConsultationDentist = ({ detail, upcomingConsultations, pastConsultations }) => {
  const dispatch = useDispatch();

  const { id } = useParams();

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");

  const handleSuspendUser = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
  };

  const handleResetUser = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  return (
    <div className="row">
      <div className="col-xl-6">
        <div className="tbl_user_info">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center flex-wrap  position-relative height45">
                <h4 className="title_text">All Consultations</h4>
              </div>

              {
                <div className=" table-responsive table-defaut-design font-weight500  special_days_table">
                  <table className="table common_table  w-100 small-table-font">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Doctor</th>
                        <th>Reviews</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody className="td_color table_fix_height">
                      {[...upcomingConsultations, ...pastConsultations].length >
                        0 ? (
                        <>
                          {upcomingConsultations?.map((consultation, i) => {
                            return (
                              <tr key={i} valign="middle">
                                <td>{MomentFunc.Date(consultation?.date)}</td>
                                <td>{MomentFunc.Time(consultation?.date)}</td>
                                <td>
                                  {`${capitalize(consultation?.assignedDoctor?.firstName || "")} ${capitalize(
                                    consultation?.assignedDoctor?.lastName || ""
                                  )}`}
                                </td>

                                <td>{consultation?.review?.dentist?.video_call_comment || "-"}</td>

                                <td className="text-center">
                                  {new Date() < moment(consultation?.date) &&
                                    new Date() >
                                    moment(consultation?.date) -
                                    10 * 60 * 1000 ? (
                                    <Link className="blue-link-under">
                                      Start Call
                                    </Link>
                                  ) : (
                                    <Link
                                      onClick={() =>
                                        cancelConsultation(consultation)
                                      }
                                      className="blue-link-under"
                                    >
                                      Cancel
                                    </Link>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                          {pastConsultations?.map((consultation, i) => {
                            return (
                              <tr key={i} valign="middle">
                                <td>{MomentFunc.Date(consultation?.date)}</td>
                                <td>{MomentFunc.Time(consultation?.date)}</td>
                                <td>
                                  {`${capitalize(consultation?.assignedDoctor?.firstName || "")} ${capitalize(
                                    consultation?.assignedDoctor?.lastName || ""
                                  )}`}
                                </td>
                                <td>{consultation?.review?.dentist?.video_call_comment || "-"}</td>
                                <td className="text-center">
                                  <Link
                                    // onClick={() =>
                                    //   handleViewNotes(consultation)
                                    // }
                                    className="blue-link-under"
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td colSpan={3} valign="middle" className="h-150">
                            <p className="no_content_table">
                              No Consultations Yet
                            </p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <div className="col-xl-3">
        <div className="card account-card-height mb-4">
          <div className="card-body details-card">
            <div className="mb-3 account-actions ">
              <h4 className="wallet-heading m-0 ">Account Actions</h4>
            </div>
            <div className="account-btns d-flex align-items-center flex-column">
              <div className="mb-2">
                {detail?.status == 0 ? (
                  <button
                    className="suspend-btn"
                    onClick={() => handleSuspendUser("userActive")}
                  >
                    Re-Activate Account
                  </button>
                ) : (
                  <button
                    className="suspend-btn"
                    onClick={() => handleSuspendUser("userSuspend")}
                  >
                    Suspend Account
                  </button>
                )}
              </div>

              <div className="mb-2">
                <button
                  className="suspend-btn"
                  onClick={() => handleResetUser("userReset")}
                >
                  Reset Password
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="col-xl-6">
        <div className="tbl_user_info">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center flex-wrap  position-relative height45">
                <h4 className="title_text">Prescriptions</h4>
                <span>
                  <Link to={`/admin/member/newPrescriptions/${id}`}>
                    <button className="btn cre_new">New Prescription</button>
                  </Link>
                </span>
              </div>

              {!viewPres ? (
                <div className="table-responsive table-defaut-design font-weight500 special_days_table">
                  <table className="table common_table w-100 small-table-font ">
                    <thead>
                      <tr>
                        <th>Issue Date</th>
                        <th>Item</th>
                        <th>Quantity</th>
                        <th></th>
                      </tr>
                    </thead>

                    <tbody className="td_color table_fix_height">
                      {prescriptions?.length > 0 ? (
                        prescriptions?.map((prescription) => {
                          return (
                            <tr valign="middle">
                              <td>{MomentFunc.Date(prescription?.date)}</td>
                              <td className="med-td">
                                <p>{prescription?.medication[0]?.meds}</p>
                              </td>
                              <td>{prescription?.medication[0]?.quantity}</td>
                              <td>
                                <Link
                                  onClick={() => handleViewPres(prescription)}
                                  className="light-blue-link-under"
                                >
                                  View
                                </Link>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={3} valign="middle" className="h-150">
                            <p className="no_content_table">
                              No Prescriptions Yet
                            </p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                <ViewPrescription
                  ref={PrescriptionRef}
                  viewPresData={viewPresData}
                  handlePrint={handlePresPrint}
                  handleClose={handleClose}
                />
              )}
            </div>
          </div>
        </div>
      </div> */}

      <ConfirmationModal
        data={id}
        isModalOpen={isModalOpen}
        selectedType={selectedType}
        handleConfirmClose={handleConfirmClose}
      />
    </div>
  );
};

export default ConsultationDentist;
